import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import AddonModal from "../../components/AddonModal"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";
import { selectStoredPermissions } from '../../stores/permissionsSlice';
import { Link , useParams, useNavigate, useSearchParams } from 'react-router-dom';
import SortableList, { SortableItem } from 'react-easy-sort';

const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [addons, setAddons] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [isModalOpen, setIsModalOpen] = useState(false);

     const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    // Initialize state from URL params
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        item_id: searchParams.get('item_id') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')) : '',
        page: parseInt(searchParams.get('page')) || 1,
    });

    
    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.item_id) params.set('item_id', apiData.item_id);
        if (apiData.daterange) params.set('daterange', JSON.stringify(apiData.daterange));
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        
        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.search, apiData.daterange, apiData.page, apiData.item_id]);

    
    useEffect(() => {
        getAddons();
    }, [apiData.page, apiData.search, apiData.daterange, apiData.item_id]); // Dependency array for re-fetching data

    const getAddons = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "addons", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setAddons(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };
    
    const handleCloseModal = () => {
        setIsModalOpen(false);
        getAddons();
    };

    const clearFilter = () => {
        setApiData({
            item_id: apiData.item_id,
            search: '',
            daterange: '',
            page: 1
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `addons/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getAddons();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `addons/status/${id}`, // Replace with your API endpoint
                data: {item_id: apiData.item_id}, 
            });
            const data = response.data;
            if (data.status) {
                getAddons();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };
// Simple array move function
    const arrayMove = (array, fromIndex, toIndex) => {
        const newArray = [...array];
        const [removed] = newArray.splice(fromIndex, 1);
        newArray.splice(toIndex, 0, removed);
        return newArray;
    };
    const onSortEndBulk = async (oldIndex, newIndex) => {
        const item_id = apiData.item_id;

        // Update local state
        const newItems = arrayMove(addons, oldIndex, newIndex);
        setAddons(newItems);
        
        // Send complete reordered list to backend
        const sortedData = newItems.map((item, index) => ({
            id: item._id,
            sort_order: index + 1 // 1-based position
        }));
        
        try {
            await ApiService.request({
                method: "POST",
                url: `updateSortOrder`, 
                data: {
                    items: sortedData,
                    type:'addon', 
                    id: item_id,
                }
            });
        } catch (error) {
            console.error('Failed to update sort:', error);
        }
    };
    const onSortEnd = async (oldIndex, newIndex) => {
        const item_id = addons[oldIndex]._id;
        const sort_order = newIndex;
        const newCategories = [...addons];
  
        const [movedItem] = newCategories.splice(oldIndex, 1);
        newCategories.splice(newIndex, 0, movedItem);
        // Update sort_order for all items
        const withUpdatedPositions = newCategories.map((item, index) => ({
            ...item,
            sort_order: index + 1  // or just index if you prefer 0-based
        }));
        setAddons(withUpdatedPositions);

        const response = await ApiService.request({
            method: "POST",
            url: `updateSortOrder`, 
            data:{ type:'addon', id: item_id, sort_order, item_id: apiData.item_id}
        });
        const data = response.data;
        if (data.status) {
            toast.success(data.message);
        } else {
            toast.error(data.message);
        }
    }


    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            Modifier Groups</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Modifier Groups</li>
                        </ul>
                    </div>
                    <div className="d-flex align-addons-center gap-2 gap-lg-3">
                        {/* Add New addons Button */}
                        <Link to={-1}  className='btn btn-secondary btn-sm'> <i className='bi bi-arrow-left'></i> Back </Link>
                        <button type='button' onClick={()=>setIsModalOpen(true)}   className='btn btn-dark btn-sm'>Add Existing Modifier</button>
                        <Link to={`/addons/create?item_id=`+apiData.item_id}  className='btn btn-base btn-sm'>Add New Modifier</Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-addons-center position-relative my-1">
                                                <input type="search" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control  me-5"
                                                 placeholder="Search Addon title.."/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control '
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <SortableList onSortEnd={onSortEndBulk} className="row" draggedItemClassName="dragged">
                                {addons.length > 0 ? addons.map((addon, index) => (
                                    <SortableItem  key={addon._id}>
                                        <div className="col-md-3 my-3" key={index}>
                                            <div className="card text-center shadow ">
                                                <Link to={`/addon_items?addon_id=${addon._id}&item_id=${apiData.item_id}`}>
                                                    <img src={addon.image} alt="image" className="w-100 h-150px object-cover" />
                                                    <h5 className='my-3'>{addon.title} ({addon.title_ar})</h5> 
                                                    
                                                </Link>

                                                <div className="row my-4 mx-2">
                                                    <div className="col-4">
                                                        {(() => {
                                                            const firstMatchingItem = addon.items.find(item => item.item_id === apiData.item_id);
                                                            return (
                                                            <div className="form-check form-switch mt-2">
                                                                <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                name="is_delivery" 
                                                                id="flexSwitchCheckChecked" 
                                                                checked={firstMatchingItem?.is_active ?? false}
                                                                onChange={() => updateStatus(addon._id)}
                                                                />
                                                            </div>
                                                            );
                                                        })()}
                                                        {/* <div className="form-check form-switch mt-2 " data-bs-toggle="tooltip" data-bs-placement="top" title="Enable/Disable Locally">
                                                            <input className="form-check-input" type="checkbox" name="is_delivery" id="flexSwitchCheckChecked" checked={addon.status}  
                                                            onClick={() => updateStatus(addon._id)}/>
                                                        </div> */}
                                                    </div>
                                                    
                                                    <div className="d-flex col-8">
                                                        <Link to={`/addon_items?addon_id=${addon._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        { selectStoredPermissions().includes('edit-addons') &&
                                                            <Link to={`/addons/create/${addon._id}?item_id=${apiData.item_id}`} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-pencil-fill fs-6"></i>
                                                            </Link>
                                                        }
                                                        { selectStoredPermissions().includes('delete-addons') &&
                                                            <button  onClick={() => delData(addon._id)} className="btn btn-sm h-30px btn-light-primary"
                                                            data-bs-toggle="tooltip" data-bs-placement="top" title="Remove Globally">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                        }
                                                    </div>

                                                </div>
                                                
                                            </div>
                                        </div>
                                    </SortableItem>
                                )) : (
                                    <h6  className="text-dark text-center mt-2"> No data found!!</h6>
                                )}
                            </SortableList>
                            <span className='mt-5'>Total Records: {pagination?.total_records}</span>
                            {pagination.total_pages > 1 && (
                                <Paginator
                                    page={pagination.current_page}
                                    rows={pagination.per_page}
                                    totalRecords={pagination.total_records}
                                    onPageChange={handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && <AddonModal itemId={apiData.item_id}  closeModal={handleCloseModal} />}

        </div>
    );
};

export default List;
